<ng-container *ngIf="order; else Spinner">
  <div class="container flex h-full flex-col">
    <!-- header -->
    <div class="header flex w-full flex-row items-center justify-between">
      <div class="title flex flex-row items-center">
        <ion-icon src="../../../assets/icon/report-icon.svg"></ion-icon>
        <h1>NOTIFICAR INCIDENCIA</h1>
      </div>
      <ion-button fill="clear" class="close-button" (click)="onCloseModal()">
        <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
      </ion-button>
    </div>
    <hr />

    <!-- contenido -->
    <h1 class="body-title">Pedido #{{ order_number }}</h1>
    <div>
      <ion-textarea
        class="commentBox_textarea"
        [autoGrow]="true"
        [counter]="true"
        maxlength="1000"
        rows="5"
        placeholder="Cuéntanos que ha ocurrido para que podamos ayudarte..."
        [(ngModel)]="text_indicent"
      >
      </ion-textarea>
    </div>

    <!-- Adjuntar imagen o vídeo -->
    <div class="mt-2">
      <label for="incident-file" class="mb-1 block">
        Adjuntar imágenes o vídeos (máx. 5 archivos, 50MB cada uno):
      </label>
      <div class="mb-2 flex flex-row items-center gap-2">
        <button
          type="button"
          class="select-file-btn bg-tertiary rounded px-3 py-2 text-white"
          (click)="fileInput.click()"
          [disabled]="filePreviews?.length >= 5"
        >
          Seleccionar archivos
        </button>
        <input
          #fileInput
          type="file"
          id="incident-file"
          accept="image/*,video/*"
          (change)="onFilesSelected($event)"
          multiple
          [disabled]="filePreviews?.length >= 5"
          style="display: none"
        />
        <span class="text-sm text-gray-500"> {{ filePreviews?.length || 0 }}/5 archivos </span>
      </div>
      <div *ngIf="filePreviews?.length" class="preview-container mt-2 grid grid-cols-2 gap-2">
        <ng-container *ngFor="let preview of filePreviews; let i = index">
          <div class="preview-item relative">
            <button
              type="button"
              class="remove-file-btn absolute right-1 top-1 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-xs text-white"
              (click)="removeFile(i)"
            >
              ×
            </button>
            <img
              *ngIf="isImage(preview.type)"
              [src]="preview.url"
              alt="Vista previa"
              class="h-32 w-full rounded object-cover"
            />
            <video *ngIf="isVideo(preview.type)" [src]="preview.url" controls class="h-32 w-full rounded"></video>
          </div>
        </ng-container>
      </div>
    </div>
    <hr />

    <p class="body-text m-0">
      Nuestro equipo se ocupará de tu incidencia lo antes posible. En meses como septiembre (debido a la temporada
      alta), este proceso podría demorar un poco. Gracias por tu paciencia.
    </p>
    <hr />

    <!-- actions -->
    <div class="flex justify-end">
      <div class="flex flex-row items-center justify-end gap-2">
        <ion-button color="medium-dark" fill="outline" (click)="onCloseModal()" [disabled]="isSending">
          Cancelar
        </ion-button>
        <ion-button color="tertiary" class="flex-grow" (click)="onSendReport()" [disabled]="isSending">
          Enviar incidencia
        </ion-button>
        <ng-container *ngIf="isSending">
          <ion-spinner name="dots"></ion-spinner>
          <span class="ml-2 text-xs text-gray-500">Enviando, esto puede tardar unos segundos...</span>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #Spinner>
  <ion-content style="margin: auto">
    <ion-row class="ion-justify-content-center ion-align-items-center" style="height: 25%">
      <ion-spinner></ion-spinner>
    </ion-row>
  </ion-content>
</ng-template>
